module.exports = __webpack_public_path__ + "img/img14.db8cfa0f.svg";